import { Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import { CloudArrowUp, Info, X } from "phosphor-react";
import { useState } from "react";
import * as Yup from "yup";
import createOrEditTeamModalStyles from "./createOrEditTeamModalStyles";
import CustomInputFieldWithFormik from "../../../Utilities/CustomInputFields/CustomInputFieldWithFormik";
import { Button, CircularProgress, TextField } from "@material-ui/core";
import { fpost } from "../../../../API/callsAPI";

const CreateOrEditTeamModal = ({
  handleClose,
  handleRefresh,
  setSnackValue,
}) => {
  const classes = createOrEditTeamModalStyles();
  const [selectedColor, setSelectedColor] = useState("#D96567");
  const [isTeamCreating, setIsTeamCreating] = useState(false);

  const validationSchema = Yup.object({
    team_name: Yup.string("String required")
      .label("assetName")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required(),
  });
  const formik = useFormik({
    initialValues: {
      team_name: "",
      description: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsTeamCreating(true);
        const createData = {
          url: "project-space/",
          data: {
            name: values.team_name,
            description: values.description,
          },
        };
        const res = await fpost(createData);
        setSnackValue({
          isOpen: true,
          message: `SuccessFully Created Team`,
          isError: false,
        });
        handleRefresh();
        setIsTeamCreating(false);
      } catch (error) {
        setSnackValue({
          isOpen: true,
          message: "Error On Create Team",
          isError: true,
        });
        console.log(error);
        setIsTeamCreating(false);
      }
    },
  });
  return (
    <Box className={classes.root}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 600,
        }}
      >
        Create a Team
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 1,
          color: "#B1B5C9",
          mb: 1,
        }}
      >
        <div>
          <Info size={20} />
        </div>
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          Teams allow you to manage projects in one place, automatically adding
          users to any new projects within that team.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "16px",
        }}
      >
        {/* <Box>
          <Box
            sx={{
              height: "160px",
              width: "160px",
              display: "block",
              backgroundColor: selectedColor,
              borderRadius: "10px",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "8px",
            }}
          >
            {[
              "#D96567",
              "#CA65D9",
              "#6C65D9",
              "#65C4D9",
              "#80D965",
              "#D9B065",
            ].map((sin) => (
              <Box
                onClick={() => setSelectedColor(sin)}
                sx={{
                  bgcolor: sin,
                  height: "20px",
                  width: "20px",
                  borderRadius: "3px",
                  display: "block",
                  border: selectedColor === sin ? "2px solid white" : "",
                  cursor: "pointer",
                }}
              ></Box>
            ))}
          </Box>
          <Button
            style={{
              marginTop: "8px",
              textAlign: "center",
              textTransform: "none",
              width: "100%",
              color: "white",
            }}
            startIcon={<CloudArrowUp />}
          >
            Upload
          </Button>
        </Box> */}
        <Box sx={{ width: "100%" }}>
          <CustomInputFieldWithFormik
            name="team_name"
            formik={formik}
            isRequired={true}
            label="Team Name"
            isDisabled={false}
          />
          <div style={{ marginTop: "16px" }}>
            <Typography style={{ marginBottom: "4px" }}>
              Team Description
            </Typography>
            <div
              className={classes.cardContentDiv3}
              style={{ marginTop: "5px" }}
            >
              <TextField
                type="text"
                id="desc"
                placeholder="Enter a description of your team"
                className={classes.cardContentInput2}
                style={{ height: "70px", overflow: "auto" }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontFamily: "Poppins",
                  },
                }}
                name="description"
                onChange={formik.handleChange}
                value={formik.values.description}
                multiline
              />
            </div>
          </div>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        <Button
          onClick={handleClose}
          className={classes.cancelButton}
          startIcon={<X />}
          disabled={isTeamCreating}
        >
          Cancel
        </Button>
        <Button
          className={classes.submitButton}
          disabled={!formik.values.team_name?.length || isTeamCreating}
          onClick={formik.handleSubmit}
        >
          {isTeamCreating ? <CircularProgress size={22} /> : "Create Team"}
        </Button>
      </Box>
    </Box>
  );
};

export default CreateOrEditTeamModal;
